/**
 * Same-tab identity change signal.
 *
 * The `storage` event only fires for OTHER tabs, so App used to poll
 * localStorage every 100ms to notice same-tab client_id / role changes
 * (login, impersonation, org-switch) — which rippled a re-render + refetch
 * storm through the shell. Instead, the few places that mutate identity call
 * `notifyIdentityChanged()`, and App reconciles on that event. No polling.
 */
export const IDENTITY_CHANGED_EVENT = 'aa:identity-changed';

export function notifyIdentityChanged(): void {
  try {
    window.dispatchEvent(new Event(IDENTITY_CHANGED_EVENT));
  } catch {
    /* non-browser / SSR — no-op */
  }
}
